import { Observable } from "rxjs";

import { Injectable, inject } from "@angular/core";

import { EvaConfirmOptions, EvaConfirmService } from "src/app/shared/ds/eva-confirm-dialog/eva-confirm.service";

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

// Navigation interne seulement : refresh et fermeture d'onglet = beforeunload du composant.
@Injectable()
export class PendingChangesGuard {
  private readonly confirmService = inject(EvaConfirmService);

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    const canDeactivate = component.canDeactivate();
    if (typeof canDeactivate !== "boolean" || canDeactivate) {
      return canDeactivate;
    }

    return new Observable<boolean>((subscriber) => {
      const answer = (leave: boolean) => () => {
        subscriber.next(leave);
        subscriber.complete();
      };
      const request: EvaConfirmOptions = {
        header: "Modifications non enregistrées",
        message: "Si vous quittez cette page, vos modifications non enregistrées seront perdues.",
        acceptLabel: "Quitter",
        rejectLabel: "Rester",
        severity: "danger",
        accept: answer(true),
        reject: answer(false),
        superseded: answer(false),
      };
      this.confirmService.confirm(request);
      return () => this.confirmService.dismiss(request);
    });
  }
}
